import { render, staticRenderFns } from "./ManageWorkspace.vue?vue&type=template&id=22f477fa"
import script from "./ManageWorkspace.vue?vue&type=script&lang=js"
export * from "./ManageWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports